import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../services/api';

export default function OptOutPage() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const response = await apiFetch('/api/opt-out', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, name, company }) });
    const payload = await response.json();
    if (!response.ok) { setError(payload.error?.formErrors?.[0] || 'Unable to submit your request. Please check the email address and try again.'); return; }
    setSubmitted(true);
  };

  return (
    <div className="legal-page">
      <header className="header">
        <div className="logo">ReachAtlas</div>
        <nav className="nav">
          <Link to="/">Home</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </nav>
      </header>

      <main className="legal-main">
        <div className="legal-content">
          <h1>Do Not Sell My Info / Opt-Out Request</h1>
          
          {!submitted ? (
            <section>
              <p>
                Where applicable, privacy laws may give you the right to opt out of the 
                sale or sharing of your personal information. If your business contact record appears in ReachAtlas, submit the work email address listed in that record below. You do not need an account.
              </p>

              <form onSubmit={handleSubmit} className="opt-out-form">
                {error && <div className="error-message" role="alert">{error}</div>}
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company (optional)</label>
                  <input
                    type="text"
                    id="company"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    placeholder="Your company name"
                  />
                </div>

                <button type="submit" className="btn-primary btn-full">
                  Submit Opt-Out Request
                </button>
              </form>

              <div className="info-box">
                <h3>What happens after you opt-out?</h3>
                <ul>
                  <li>Your email will be added to our suppression list</li>
                  <li>The matching email is suppressed from search, exports, and future imports</li>
                  <li>Your request is recorded as soon as you submit it</li>
                </ul>
              </div>

              <div className="info-box">
                <h3>Already opted out?</h3>
                <p>
                  If you've previously submitted an opt-out request, your email is already on our 
                  suppression list and matching records remain blocked from ReachAtlas search and exports.
                </p>
              </div>
            </section>
          ) : (
            <section className="success-message">
              <h2>✅ Opt-Out Request Received</h2>
              <p>
                Your request has been recorded and suppression has been applied to matching records. They are blocked from ReachAtlas search, viewing, exports, and future imports.
              </p>
              <p>Your email address has been added to our suppression list. This does not recall files previously downloaded by customers. For corrections, deletion, or another privacy request, email <a href="mailto:support@reachatlasleads.com">support@reachatlasleads.com</a>.</p>
              <Link to="/" className="btn-primary">Return Home</Link>
            </section>
          )}

          <footer className="legal-footer">
            <p>Last updated: October 29, 2026</p>
          </footer>
        </div>
      </main>
    </div>
  );
}
